/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2023] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetAWPackageCustomerOrderDeliverySchedules(awPackageId) {
  const response = await $.soap({
    body: {
      GetAWPackageCustomerOrderDeliverySchedules: {
        $xmlns: 'http://dla.mil/ems/bpm/aw_package',
        AWPackageID: awPackageId
      }
    },
    blueprintArrays: ['GetAWPackageCustomerOrderDeliverySchedulesResponse.Response.CustomerOrderDeliverySchedule'],
    blueprint: {
      customerOrderDeliverySchedules: [
        '$..CustomerOrderDeliverySchedule',
        {
          id: '$.ID',
          clin: '$.CLIN',
          lineNumber: '$.LineNumber',
          lineCLIN: '$.LineCLIN',
          price: '$.Price',
          model: '$.Model',
          volumeBand: '$.VolumeBand',
          paperCapacityHandling: '$.PaperCapacityHandling',
          isColor: '$.IsColor',
          isNipr: '$.IsNIPR',
          optionalAccessories: '$.OptionalAccessories',
          laserPrinterTonerCartridgeType: '$.LaserPrinterTonerCartridgeType',
          customDescription: '$.CustomDescription',
          description: '$.Description',
          configurationAndPricing: '$.ConfigurationAndPricing',
          deliveryPOCFirstName: '$.DeliveryPOCFirstName',
          deliveryPOCLastName: '$.DeliveryPOCLastName',
          deliveryPOCEmail: '$.DeliveryPOCEmail',
          deliveryPOCPhone: '$.DeliveryPOCPhone',
          itPOCFirstName: '$.ITPOCFirstName',
          itPOCLastName: '$.ITPOCLastName',
          itPOCEmail: '$.ITPOCEmail',
          itPOCPhone: '$.ITPOCPhone',
          finPOCFirstName: '$.FinPOCFirstName',
          finPOCLastName: '$.FinPOCLastName',
          finPOCEmail: '$.FinPOCEmail',
          finPOCPhone: '$.FinPOCPhone',
          address: {
            addressLine1: '$..Address1',
            addressLine2: '$..Address2',
            buildingFloorNumber: '$..BuildingFloorNumber',
            floorNumber: '$..FloorNumber',
            roomNumber: '$..RoomNumber',
            poleNumber: '$..PoleNumber',
            suite: '$..Suite',
            roomPoleNumber: '$..RoomPoleNumber',
            city: '$..City',
            zip: '$..Zip',
            regionId: '$..RegionID',
            regionCode: '$..RegionCode',
            regionName: '$..RegionName'
          },
          commandName: '$.CommandName',
          termingSerialNumber: '$.TermingSerialNumber',
          isReplacement: '$.IsReplacement',
          network: '$.Network',
          trainingType: '$.TrainingType',
          trainingTypeId: '$.TrainingTypeID',
          branchName: '$.BranchName',
          additionalServiceId: '$.AdditionalServiceID',
          additionalServiceCLIN: '$.AdditionalServiceCLIN',
          additionalService: '$.AdditionalService',
          additionalAccessoryId: '$.AdditionalAccessoryID',
          additionalAccessoryCLIN: '$.AdditionalAccessoryCLIN',
          additionalAccessory: '$.AdditionalAccessory',
          mfdAdditionalService: '$.MFDAdditionalService',
          commandEchelon: '$.CommandEchelon',
          trackerNumber: '$.TrackerNumber',
          note: '$.Note',
          equipmentName: '$.EquipmentName'
        }
      ]
    }
  });

  cleanUpResponse(response);

  _.each(response.customerOrderDeliverySchedules, (deliverySchedule) => {
    deliverySchedule.deliveryPOCName = deliverySchedule.deliveryPOCFirstName
      ? `${deliverySchedule.deliveryPOCFirstName} ${deliverySchedule.deliveryPOCLastName}`
      : '--';
    deliverySchedule.itPOCName = deliverySchedule.itPOCFirstName
      ? `${deliverySchedule.itPOCFirstName} ${deliverySchedule.itPOCLastName}`
      : '--';
    deliverySchedule.finPOCName = deliverySchedule.finPOCFirstName
      ? `${deliverySchedule.finPOCFirstName} ${deliverySchedule.finPOCLastName}`
      : '--';
  });

  return response.customerOrderDeliverySchedules;
}
